import { defineStore } from 'pinia';
import { useMilkomedaWSCBridge } from '@/composables/milkomeda-wrapped-smartcontract/useMilkomedaWSCBridge';

export const useStakingMilkomedaWSCBridge = defineStore('stakingMilkomedaWSCBridge', () => {
  const milkomedaWSCBridge = useMilkomedaWSCBridge();

  return {
    ...milkomedaWSCBridge,
  };
});
